const defaultBaseUrl = 'https://www.cltairport.com/';

export function getBaseUrl() {
	return process.env.SITE_ROOT ?? defaultBaseUrl;
}
